import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { Genre } from '../../models/Genre';
export interface GenreResponse {
  status: string;
  message: string;
  data: Genre[];
}
const config = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const service = {
  addGenre(body: any): Promise<CommonResponse<Genre>> {
    const url = `genre`;
    return axiosClient.post(url, body, config);
  },
};

export default service;
